import { Navigate, useParams, useSearchParams } from 'react-router'

import { useFeatureFlags } from '@/stores/use-feature-flags'

import { RouteFallback } from '../route-fallback'

export function BotDefaultRedirect() {
  const { botId } = useParams()
  const [searchParams] = useSearchParams()
  const { featureFlags, isLoaded } = useFeatureFlags()

  if (!isLoaded) {
    return <RouteFallback />
  }

  const queryString = searchParams.toString()
  const defaultPath = featureFlags.finn ? 'finn' : 'builder'

  return (
    <Navigate to={`/bots/${botId}/${defaultPath}?${queryString}`} replace />
  )
}
